import React from "react";

import OmniFormGroup from "../Shared/OmniFormGroup/OmniFormGroup";
import "react-datetime/css/react-datetime.css";
import { Formik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  name: Yup.string().required("Name is required."),
  clientAccountCode: Yup.string().required("Client Account Code is required."),
  industry: Yup.string().required("Industry is required."),
  region: Yup.string().required("Region is required."),
  phone: Yup.string().required("Phone is required."),
});
export const Form = ({ formValues, handleSubmit, _ }) => {
  Object.keys(formValues).forEach((k) => {
    if (!formValues[k]) {
      formValues[k] = "";
    }
  });

  return (
    <Formik
      initialValues={{
        ...formValues,
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        handleSubmit({ ...values, type: "Client" }, () => {
          setSubmitting(false);
        });
      }}
      validationSchema={validationSchema}
    >
      {({ values, handleChange, handleSubmit, isSubmitting, isValid }) => (
        <div className="container">
          <div className="row mb-2">
            <div className="col">
              <OmniFormGroup
                Id="name"
                Name="name"
                Type="text"
                Placeholder={_.ClientHub.ClientAccountDetails.AccountName}
                LabelName={
                  <>
                    {_.ClientHub.ClientAccountDetails.AccountName}{" "}
                    <span className="required"></span>
                  </>
                }
                Value={values.name}
                onChange={handleChange}
                Disabled={true}
              ></OmniFormGroup>
            </div>
            <div className="col">
              <OmniFormGroup
                Id="clientAccountCode"
                Name="clientAccountCode"
                Type="text"
                Placeholder={_.ClientHub.ClientAccountDetails.AccountCode}
                LabelName={
                  <>
                    {_.ClientHub.ClientAccountDetails.AccountCode}{" "}
                    <span className="required"></span>
                  </>
                }
                Value={values.clientAccountCode}
                onChange={handleChange}
                Disabled={true}
              ></OmniFormGroup>
            </div>
            <div className="col"></div>
          </div>
          <div className="row mb-2">
            <div className="col">
              <OmniFormGroup
                Id="industry"
                Name="industry"
                Type="text"
                Placeholder={_.ClientHub.ClientAccountDetails.Industry}
                LabelName={
                  <>
                    {_.ClientHub.ClientAccountDetails.Industry}{" "}
                    <span className="required"></span>
                  </>
                }
                Value={values.industry}
                onChange={handleChange}
              ></OmniFormGroup>
            </div>
            <div className="col">
              <OmniFormGroup
                Id="region"
                Name="region"
                Type="text"
                Placeholder={_.ClientHub.ClientAccountDetails.Region}
                LabelName={
                  <>
                    {_.ClientHub.ClientAccountDetails.Region}{" "}
                    <span className="required"></span>
                  </>
                }
                Value={values.region}
                onChange={handleChange}
              ></OmniFormGroup>
            </div>
            <div className="col">
              <OmniFormGroup
                Id="accountEmail"
                Name="accountEmail"
                Type="email"
                Placeholder={_.ClientHub.ClientAccountDetails.AccountEmail}
                LabelName={_.ClientHub.ClientAccountDetails.AccountEmail}
                Value={values.accountEmail}
                onChange={handleChange}
              ></OmniFormGroup>
            </div>
          </div>
          <div className="row mb-2 mt-5">
            <div className="col">
              <OmniFormGroup
                Id="phone"
                Name="phone"
                Type="text"
                Placeholder="07984 343 545"
                LabelName={_.ClientHub.ClientAccountDetails.TelephoneNumber}
                Value={values.phone}
                onChange={handleChange}
              ></OmniFormGroup>
            </div>
            <div className="col">
              <OmniFormGroup
                Id="mailingStreet"
                Name="mailingStreet"
                Type="text"
                Placeholder={_.ClientHub.ClientAccountDetails.MailingStreet}
                LabelName={_.ClientHub.ClientAccountDetails.MailingStreet}
                Value={values.mailingStreet}
                onChange={handleChange}
              ></OmniFormGroup>
            </div>
            <div className="col">
              <OmniFormGroup
                Id="mailingCity"
                Name="mailingCity"
                Type="text"
                Placeholder={_.ClientHub.ClientAccountDetails.MailingCity}
                LabelName={_.ClientHub.ClientAccountDetails.MailingCity}
                Value={values.mailingCity}
                onChange={handleChange}
              ></OmniFormGroup>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col">
              <OmniFormGroup
                Id="mailingState"
                Name="mailingState"
                Type="text"
                Placeholder={
                  _.ClientHub.ClientAccountDetails.MailingStateProvince
                }
                LabelName={
                  _.ClientHub.ClientAccountDetails.MailingStateProvince
                }
                Value={values.mailingState}
                onChange={handleChange}
              ></OmniFormGroup>
            </div>
            <div className="col">
              <OmniFormGroup
                Id="mailingPostalCode"
                Name="mailingPostalCode"
                Type="text"
                Placeholder={_.ClientHub.ClientAccountDetails.MailingPostCode}
                LabelName={_.ClientHub.ClientAccountDetails.MailingPostCode}
                Value={values.mailingPostalCode}
                onChange={handleChange}
              ></OmniFormGroup>
            </div>
            <div className="col">
              <OmniFormGroup
                Id="mailingCountry"
                Name="mailingCountry"
                Type="select"
                Placeholder="Type of Breach"
                LabelName={_.ClientHub.ClientAccountDetails.MailingCountry}
                Value={values.mailingCountry}
                onChange={handleChange}
              >
                <option>Select</option>
                <option>United Kingdom</option>
                <option>Nederland</option>
                <option>Germany</option>
              </OmniFormGroup>
            </div>
          </div>
          <button
            className="mt-5 d-flex justify-content-between styled-button "
            type="submit"
            disabled={isSubmitting || !isValid}
            onClick={handleSubmit}
          >
            {_.ClientHub.ClientAccountDetails.SaveAccountDetails}
          </button>
        </div>
      )}
    </Formik>
  );
};
